import React from 'react'

const LocationInput = React.createClass({
  componentDidMount: function() {
    this.onAutocomplete()
  },

  onAutocomplete: function() {
    SS.locationAutocomplete(`.location-${this.props.guId}`, this.props.handleAutocompleteSelection)
  },

  render: function() {
    return(
      <input type="text"
        name="location"
        id={`location-${this.props.guId}`}
        className={`form-control location-${this.props.guId} ${this.props.inputClass}`}
        placeholder={this.props.placeholder || "Enter Postcode or Suburb"}
        value={this.props.suburb}
        data-suburb-id={this.props.suburbId || "0"}
        onChange={this.props.handleLocationChange}
      />
    )
  }
})

export default LocationInput
